import { render, staticRenderFns } from "./BrandCarSeriesModelsField.vue?vue&type=template&id=2d6e27b2&scoped=true"
import script from "./BrandCarSeriesModelsField.vue?vue&type=script&lang=ts"
export * from "./BrandCarSeriesModelsField.vue?vue&type=script&lang=ts"
import style0 from "./BrandCarSeriesModelsField.vue?vue&type=style&index=0&id=2d6e27b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6e27b2",
  null
  
)

export default component.exports